import React from "react";
import Hero from "../components/hero/Hero";
import Shoe from "../assets/shoe.png";
import ReactStars from "react-rating-stars-component";
import { useHistory } from "react-router-dom";
import { AppContext } from "../components/context/AppContext";

import BottomProductInfo from "../components/productDetails/BottomProductInfo";

const firstExample = {
  size: 13,
  value: 4.5,
  edit: false,
  color: "#EAEAEA",
  activeColor: "#FFD800",
};

const RecommendProduk = () => {
  const { RecommendationProduct } = React.useContext(AppContext);
  const history = useHistory();
  const nav = () => {
    history.push("/");
    window.scrollTo(0, 0);
  };
  return (
    <div className="detail-produk">
      <Hero hide={false} />
      <div className="detail-produk-menu container">
        <div className="navigation-tab">
          <p className="navigation-tab-inactive" onClick={nav}>
            Beranda
          </p>
          <p className="navigation-tab-arrow">></p>
          <p className="navigation-tab-inactive">Fashion Pria</p>
          <p className="navigation-tab-arrow">></p>
          <p className="navigation-tab-inactive">Sepatu Pria</p>
          <p className="navigation-tab-arrow">></p>
          <p className="navigation-tab-active">Sepatu Yeezy 350 v2 Black Red</p>
        </div>
        <div className="detail-produk-wrapper">
          <div className="useless-box"></div>
          <div className="recommend-produk">
            <div className="recommend-produk-header">
              <p className="header-text-left">
                Rekomendasi Sepatu Pria Untuk Anda
              </p>
              <p className="header-text-right">Lihat Semua</p>
            </div>
            {RecommendationProduct.map((res) => (
              <div className="recommend-produk-card">
                <img src={Shoe} className="recommend-produk-img" />
                <div className="information-produk">
                  <p className="title-produk">{res.productName}</p>

                  <div className="flexing-text">
                    <div className="star">
                      <ReactStars {...firstExample} />
                      <p className="terjual">
                        <p className="terjual-blue">{res.selling}</p>
                        <p className="terjual-grey"> terjual</p>
                      </p>
                    </div>

                    <div className="price">
                      <p className="cross-line">{res.price}</p>
                      <p className="red-text">{res.discountPrice}</p>
                    </div>

                    <div className="box-text">
                      <p className="red-box">{res.discount}</p>
                      <p className="grey-box">Gratis Ongkir</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <BottomProductInfo />
    </div>
  );
};

export default RecommendProduk;
